<div *ngIf="!plt.is('cordova')"
     class="row">
    <h2>{{ 'CUSTOM_PARTERS_TITLE' | translate }}</h2>
    <!-- <p [innerHtml]="'CUSTOM_PARTNERS_TEXT' | translate"></p> -->

    <div class="wrapper">
        <ion-row>
            <ion-col col-sm="6"
                     col-md="4">
                <a href="https://www.gasq.org"
                   target="_blank"
                   class="link logo">
                    <img src="/assets/images/theme/partners/logo-gasq.svg"
                         alt="GASQ"
                         style="height:35px;" />
                </a>
            </ion-col>
            <ion-col col-sm="6"
                     col-md="4">
                <a href="https://www.isqi.org"
                   target="_blank"
                   class="link logo">
                    <img src="/assets/images/theme/partners/logo-isqi.png"
                         alt="ISQI"
                         style="height:120px;" />
                </a>
            </ion-col>
            <ion-col col-sm="6"
                     col-md="4">
                <a href="https://www.alliance4qualification.info/"
                   target="_blank"
                   class="link logo">
                    <img src="/assets/images/theme/partners/logo-a4q.webp"
                         alt="A4Q"
                         style="height:70px;" />
                </a>
            </ion-col>
        </ion-row>
    </div>
</div>